export default __webpack_public_path__ + "static/media/teaching.9ec6dc9a.svg";